module.exports = __webpack_public_path__ + "img/demo11.61151a70.svg";